import React, { useEffect, useState } from 'react';

// Reduced refresh rates to prevent RPC overload and flaky calls
const FAST_INTERVAL = 10000; // Changed from 5000ms (5s) to 10000ms (10s)
const SLOW_INTERVAL = 60000; // Changed from 30000ms (30s) to 60000ms (60s)

export const RefreshContext = React.createContext({ slow: 0, fast: 0 });

// This context maintain 2 counters that can be used as a dependencies on other hooks to force a periodic refresh
export const RefreshContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [slow, setSlow] = useState(0);
  const [fast, setFast] = useState(0);

  useEffect(() => {
    const interval = setInterval(async () => {
      setFast((prev) => prev + 1);
    }, FAST_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(async () => {
      setSlow((prev) => prev + 1);
    }, SLOW_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return <RefreshContext.Provider value={{ slow, fast }}>{children}</RefreshContext.Provider>;
};
